

















































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { MagazineFilterValues } from '@/store/storeStateInterfaces';
import Magazine from '@/models/Magazine';
import EventBus from '@/misc/EventBus';
import Bookmark from '@/models/Bookmark';
import Theme from '@/models/Theme';

const MagazineStore = namespace('magazine');
const ApplicationStore = namespace('application');
const BookmarkStore = namespace('bookmark');

interface MenuItem {
    title: string,
    routerLink: string
}

@Component({
    components: {
        SearchBarComponent: () => import(
            /* webpackChunkName: "SearchBarComponent" */
            '@/components/library/SearchBar.component.vue'),
        ResponsiveButtonComponent: () => import(
            /* webpackChunkName: "ResponsiveButtonComponent" */
            '@/components/shared/ResponsiveButton.component.vue'),
        LocaleSwitcher: () => import(
            /* webpackChunkName: "LocaleSwitcher" */
            '@/components/locale/LocaleSwitcher.component.vue')
    }
})
export default class NavigationHeaderView extends Vue {

    public showMagazineSearch = false;

    @ApplicationStore.Getter('accessibilityControls')
    private accessibilityControls!: boolean;

    @ApplicationStore.Mutation('setAccessibilityControls')
    private setAccessibilityControls!: (enabled: boolean) => void;

    @MagazineStore.Getter('filterValues')
    private _filterValues!: MagazineFilterValues;

    @MagazineStore.Getter('selectedMagazine')
    private selectedMagazine!: Magazine;

    @ApplicationStore.Getter('navigationTitle')
    private navigationTitle!: string;

    @ApplicationStore.Getter('categoryMenu')
    public categoryMenu!: boolean;

    @ApplicationStore.Mutation('setCategoryMenu')
    private setCategoryMenu!: (value: boolean) => void;

    @ApplicationStore.Getter('languageDialog')
    public languageDialog!: boolean;

    @ApplicationStore.Mutation('setLanguageDialog')
    private setLanguageDialog!: (value: boolean) => void;

    @BookmarkStore.Getter('activeBookmark')
    private activeBookmark?: Bookmark;

    @ApplicationStore.Getter('customTheme')
    private customTheme!: Theme;

    public isFullscreen: boolean = !!document.fullscreenElement;

    get showXsOptions(): boolean {
        return !this.showMagazineSearch && this.$vuetify.breakpoint.xsOnly;
    }

    get isShowRoomMode(): boolean {
        return process.env.VUE_APP_SHOW_ROOM_MODE === 'true';
    }

    get menuInformation() {
        return [{
            title: this.$t('GENERAL.IMPRINT').toString(),
            routerLink: process.env.VUE_APP_IMPRINT_LINK!
            }, {
            title: this.$t('GENERAL.PRIVACY').toString(),
            routerLink: process.env.VUE_APP_PRIVACY_POLICY_LINK!
            }, {
            title: this.$t('GENERAL.CONDITIONS').toString(),
            routerLink: process.env.VUE_APP_TERMS_AND_CONDITIONS_LINK!
            }];
    }

    /**
     * Returns the current filter and language in a handy string!
     */
    get navigationSubtitle(): string {
        let language = '';

        if (!this._filterValues.languages.includes('all')) {
            if (this._filterValues.languages.length > 2) {
                language = `${this._filterValues.languages[0].toUpperCase()}+${this._filterValues.languages.length - 1}`;
            } else {
                language = this._filterValues.languages
                    .map(lang => lang.toUpperCase()).join();
            }
        }

        const category = this._filterValues.category ? this._filterValues.category!.name : '';
        return `${language}${language && category ? ' | ' : ''}${category}`;
    }

    public created() {
        // handle fullscreen state changes
        this.$fullscreen.addOnFullscreenChangeNotifyFn((value: boolean) => {
            this.isFullscreen = value;
        });
    }

    /**
     * Toggles the category menu
     */
    public categoryButtonClicked() {
        this.setCategoryMenu(!this.categoryMenu);
    }

    public goBack() {
        this.$router.go(-1);
    }

    /**
     * Toggles the language dialog
     */
    public languageButtonClicked() {
        this.setLanguageDialog(!this.languageDialog);
    }

    public bookMarkClicked() {
        EventBus.$emit('BOOKMARK_CLICKED');
    }

    public toggleAccessibilityControls() {
        this.setAccessibilityControls(!this.accessibilityControls);
    }

    public openMenuItem(menuItem: MenuItem) {
        if (menuItem.routerLink) {
            window.open(menuItem.routerLink, '_blank');
        }
    }

    public showMagazineSearchClicked(showSearch: boolean) {
        this.showMagazineSearch = showSearch;
    }

    /**
     * Toggle fullscreen handler
     */
    public onFullscreenToggleClicked() {
        this.$fullscreen.toggleFullscreen();
    }

    /**
     * Get the logo source
     */
    public logoSrc(): string {
        let src;
        try {
            src = require(`@/assets/themes/${this.customTheme?.token}/logo.png`);
        } catch (e) {
            src = require('@/assets/themes/default/logo.png');
        }
        return src;
    }
};
